import type { IPoiPendingImage } from '@/shared/api/types/poi-types'
import { useTranslation } from 'react-i18next'
import { PoiImageUpload } from '@/features/poi/poi-image-upload'
import { cn } from '@/shared/libs/cn'
import { FormSectionCard } from '@/shared/ui/form-section-card'
import { SectionSaveButton } from '@/shared/ui/section-save-button'

interface MediaCardProps {
  isEdit: boolean
  isFormReady: boolean
  images: IPoiPendingImage[]
  onChange: (images: IPoiPendingImage[]) => void
  onFilesSelected: (files: File[]) => Promise<void>
  isDirty: boolean
  isSaving: boolean
  /** Save is blocked while another save runs or an upload is still in progress. */
  isSaveBlocked: boolean
  onSave: () => void
}

/** Images of the POI (at least one is required). */
export function MediaCard({
  isEdit,
  isFormReady,
  images,
  onChange,
  onFilesSelected,
  isDirty,
  isSaving,
  isSaveBlocked,
  onSave,
}: MediaCardProps) {
  const { t } = useTranslation()

  return (
    <FormSectionCard
      title={t('poi.media.title')}
      action={
        isEdit && (
          <SectionSaveButton
            disabled={isSaveBlocked || !isDirty}
            saving={isSaving}
            onSave={onSave}
          />
        )
      }
    >
      <div className={cn(!isFormReady && 'opacity-50 pointer-events-none')}>
        <p className="mb-3 text-sm font-medium text-zinc-700">
          {t('poi.media.images')} <span className="text-red-500">*</span>
        </p>
        <PoiImageUpload images={images} onChange={onChange} onFilesSelected={onFilesSelected} />
      </div>
    </FormSectionCard>
  )
}
